import { SupplierModel } from "../models/SupplierModel";

// import { SupplierModel } from "../models/SupplierModel"
export const initialSuppliers: SupplierModel[] = [
   {
    "supCode": "SUP011",
    "name": "Office Depot Supply Co.",
    "email": "support@officedepot.com",
    "phone": "800-555-1100",
    "fax": "800-555-1101",
    "addr1": "6600 North Military Trail",
    "addr2": "",
    "city": "Boca Raton",
    "state": "FL",
    "zip": "33496",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Customer Service",
    "regrinder": false,
    "calibrator": false,
    "serviceFee": 0,
    "active": true,
    "notes": "Office supplies, paper, toner, general consumables"
  },
  {
    "supCode": "SUP012",
    "name": "Fastenal Industrial Supplies",
    "email": "sales@fastenal.com",
    "phone": "507-555-1200",
    "fax": "507-555-1201",
    "addr1": "2001 Theurer Blvd",
    "addr2": "",
    "city": "Winona",
    "state": "MN",
    "zip": "55987",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Branch Manager",
    "regrinder": false,
    "calibrator": false,
    "serviceFee": 0,
    "active": true,
    "notes": "Bolts, screws, nuts, washers, MRO supplies"
  },
  {
    "supCode": "SUP013",
    "name": "Grainger Industrial Supply",
    "email": "service@grainger.com",
    "phone": "847-555-1300",
    "fax": "847-555-1301",
    "addr1": "100 Grainger Parkway",
    "addr2": "",
    "city": "Lake Forest",
    "state": "IL",
    "zip": "60045",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Account Rep",
    "regrinder": false,
    "calibrator": false,
    "serviceFee": 0,
    "active": true,
    "notes": "Industrial parts, safety equipment, fasteners"
  },
  {
    "supCode": "SUP001",
    "name": "Precision Tools Inc.",
    "email": "contact@precisiontools.com",
    "phone": "714-555-1001",
    "fax": "714-555-1002",
    "addr1": "123 Industrial Way",
    "addr2": "Suite 200",
    "city": "Irvine",
    "state": "CA",
    "zip": "92618",
    "country": "USA",
    "currencyType": "USD",
    "contact": "John Smith",
    "regrinder": true,
    "calibrator": false,
    "serviceFee": 150.5,
    "active": true,
    "notes": "Preferred supplier for cutting tools"
  },
  {
    "supCode": "SUP002",
    "name": "Global Calibration Services",
    "email": "info@globalcal.com",
    "phone": "949-555-2001",
    "fax": "949-555-2002",
    "addr1": "456 Tech Blvd",
    "addr2": "",
    "city": "Costa Mesa",
    "state": "CA",
    "zip": "92626",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Sarah Lee",
    "regrinder": false,
    "calibrator": true,
    "serviceFee": 200.0,
    "active": true,
    "notes": "Calibration certified ISO 17025"
  },
  {
    "supCode": "SUP003",
    "name": "Tool Masters",
    "email": "sales@toolmasters.com",
    "phone": "562-555-3001",
    "fax": "562-555-3002",
    "addr1": "789 Manufacturing Rd",
    "addr2": "",
    "city": "Long Beach",
    "state": "CA",
    "zip": "90805",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Mike Johnson",
    "regrinder": true,
    "calibrator": false,
    "serviceFee": 120.75,
    "active": true,
    "notes": ""
  },
  {
    "supCode": "SUP004",
    "name": "Advanced Tooling",
    "email": "support@advtool.com",
    "phone": "310-555-4001",
    "fax": "310-555-4002",
    "addr1": "321 Precision Ln",
    "addr2": "Building B",
    "city": "Torrance",
    "state": "CA",
    "zip": "90501",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Emily Davis",
    "regrinder": true,
    "calibrator": true,
    "serviceFee": 175.0,
    "active": true,
    "notes": "Handles both regrind and calibration"
  },
  {
    "supCode": "SUP005",
    "name": "Industrial Supplies Co.",
    "email": "info@indsupply.com",
    "phone": "626-555-5001",
    "fax": "626-555-5002",
    "addr1": "654 Supply St",
    "addr2": "",
    "city": "Pasadena",
    "state": "CA",
    "zip": "91101",
    "country": "USA",
    "currencyType": "USD",
    "contact": "David Brown",
    "regrinder": false,
    "calibrator": false,
    "serviceFee": 90.0,
    "active": true,
    "notes": "General supply vendor"
  },
  {
    "supCode": "SUP006",
    "name": "Metro Tool Repair",
    "email": "repair@metrotool.com",
    "phone": "213-555-6001",
    "fax": "213-555-6002",
    "addr1": "987 Repair Ave",
    "addr2": "",
    "city": "Los Angeles",
    "state": "CA",
    "zip": "90012",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Chris White",
    "regrinder": true,
    "calibrator": false,
    "serviceFee": 110.0,
    "active": true,
    "notes": "Quick turnaround service"
  },
  {
    "supCode": "SUP007",
    "name": "CalPro Systems",
    "email": "service@calpro.com",
    "phone": "858-555-7001",
    "fax": "858-555-7002",
    "addr1": "159 Calibration Dr",
    "addr2": "",
    "city": "San Diego",
    "state": "CA",
    "zip": "92121",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Laura Green",
    "regrinder": false,
    "calibrator": true,
    "serviceFee": 210.25,
    "active": true,
    "notes": ""
  },
  {
    "supCode": "SUP008",
    "name": "West Coast Tools",
    "email": "wc@tools.com",
    "phone": "408-555-8001",
    "fax": "408-555-8002",
    "addr1": "753 Silicon Ave",
    "addr2": "",
    "city": "San Jose",
    "state": "CA",
    "zip": "95112",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Kevin Moore",
    "regrinder": true,
    "calibrator": false,
    "serviceFee": 130.0,
    "active": true,
    "notes": ""
  },
  {
    "supCode": "SUP009",
    "name": "Precision Calibrators",
    "email": "pc@calibrators.com",
    "phone": "650-555-9001",
    "fax": "650-555-9002",
    "addr1": "852 Accuracy Blvd",
    "addr2": "",
    "city": "San Mateo",
    "state": "CA",
    "zip": "94401",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Nancy Taylor",
    "regrinder": false,
    "calibrator": true,
    "serviceFee": 195.5,
    "active": true,
    "notes": "High precision instruments"
  },
  {
    "supCode": "SUP010",
    "name": "Tool & Service Hub",
    "email": "hub@toolservice.com",
    "phone": "916-555-1010",
    "fax": "916-555-1011",
    "addr1": "147 Service Park",
    "addr2": "",
    "city": "Sacramento",
    "state": "CA",
    "zip": "95814",
    "country": "USA",
    "currencyType": "USD",
    "contact": "Robert King",
    "regrinder": true,
    "calibrator": true,
    "serviceFee": 160.0,
    "active": true,
    "notes": "Full-service provider"
  },

  {
  supCode: "SUP014",
  name: "DEWALT Industrial Tools",
  email: "support@dewalt.com",
  phone: "800-433-9258",
  fax: "",
  addr1: "701 East Joppa Rd",
  addr2: "",
  city: "Towson",
  state: "MD",
  zip: "21286",
  country: "USA",
  currencyType: "USD",
  contact: "Sales Support",
  regrinder: false,
  calibrator: false,
  serviceFee: 0,
  active: true,
  notes: "Power tools manufacturer"
},
{
  supCode: "SUP015",
  name: "Bosch Tools USA",
  email: "service@boschtools.com",
  phone: "877-267-2499",
  fax: "",
  addr1: "38000 Hills Tech Dr",
  addr2: "",
  city: "Farmington Hills",
  state: "MI",
  zip: "48331",
  country: "USA",
  currencyType: "USD",
  contact: "Customer Service",
  regrinder: false,
  calibrator: false,
  serviceFee: 0,
  active: true,
  notes: "Bosch industrial and power tools"
},
{
  supCode: "SUP016",
  name: "Klein Tools",
  email: "customerservice@kleintools.com",
  phone: "800-553-4676",
  fax: "",
  addr1: "450 Bond St",
  addr2: "",
  city: "Lincolnshire",
  state: "IL",
  zip: "60069",
  country: "USA",
  currencyType: "USD",
  contact: "Customer Support",
  regrinder: false,
  calibrator: false,
  serviceFee: 0,
  active: true,
  notes: "Hand tools and electrical tools"
},
]